import React from 'react';
import { StyleSheetController } from './_style_sheet_controller';

export interface VisibaCortexHeadLessStackProps {
	spacing: number;
	axis: Axis;
	fluid: boolean;
}

interface HeadLessProps {
	parentClassName: string;
	childClassName: string;
}
export type Axis = 'Vertical' | 'Horizontal';

interface InternalProps extends VisibaCortexHeadLessStackProps {
	children: (props: HeadLessProps) => JSX.Element;
}

const styleSheetController = new StyleSheetController();

/**
 * # cortex:react-ui-std:comp:HeadlessStack
 */
export const HeadLessStack: React.FC<InternalProps> = ({ axis, fluid, spacing, children }) => {
	const halfSpacing = spacing / 2;
	const baseStr = `${spacing}_${fluid ? 'y' : 'n'}_${axis === 'Vertical' ? 'v' : 'h'}`;
	const parentClassName = `p_${baseStr}`;
	const childClassName = `c_${baseStr}`;

	if (axis === 'Vertical') {
		styleSheetController
			.addToRegister(
				`.${parentClassName}`,
				`
					display: flex;
					${fluid ? `height: calc(100% + ${spacing}px);` : ''}
					flex-direction: column;
					margin-top: -${halfSpacing}px!important;
					margin-bottom: -${halfSpacing}px!important;
				`,
			)
			.addToRegister(
				`.${childClassName}`,
				`
					${fluid ? `height: 100%;` : ''}
					margin-top: ${halfSpacing}px!important;
					margin-bottom: ${halfSpacing}px!important;
				`,
			);
	} else {
		styleSheetController
			.addToRegister(
				`.${parentClassName}`,
				`
				display: flex;
				${fluid ? `width: calc(100% + ${spacing}px);` : ''}
				flex-direction: row;
				margin-left: -${halfSpacing}px!important;
				margin-right: -${halfSpacing}px!important;
			`,
			)
			.addToRegister(
				`.${childClassName}`,
				`
				${fluid ? `width: 100%;` : ''}
				margin-left: ${halfSpacing}px!important;
				margin-right: ${halfSpacing}px!important;
			`,
			);
	}

	return children({
		parentClassName: parentClassName,
		childClassName: childClassName,
	});
};
